import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request)
            .pipe(
                tap({
                    error: (error: unknown) => {
                        if (error instanceof HttpErrorResponse) {
                            if (error.status === 401 || error.status === 403) {
                                void this.router.navigate([
                                    '/', 
                                ], {
                                    queryParams: {
                                        error: 'true',
                                    },
                                });
                            }
                        }
                    },
                }),
            );
    }
}
